import styles from "./index.module.css";
import Grid from "@mui/material/Grid";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import argentinaFlag from "../../assets/argentina-flag.png";
import brazilFlag from "../../assets/brazil-falg.png";
import { languages } from "../../config/strings";
import { updateLanguage } from "../../store/slices/localSlice";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { LogoLoader } from "../Shared/SkeletonLoaders";

export const Header = () => {
  const [logo, setLogo] = useState("");
  const { currentLogo } = useSelector((state) => state.local);
  const { language } = useSelector((state) => state.local);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    setLogo(currentLogo?.imgBase64);
  }, [currentLogo]);

  const changeLanguage = (lng) => {
    dispatch(updateLanguage(lng));
    Swal.fire({
      icon: "success",
      title: `${t("selectedLanguage")}: ${lng === "es" ? "Español" : "Português"}`,
      showConfirmButton: false,
      timer: 1200,
    });
  };

  return (
    <Grid container className={styles.container}>
      <Grid item xs={7} md={9} className={styles.logo} sx={{ mb: 1 }}>
        {logo?.length ? (
          <img className={styles.headerLogo} src={logo} alt="logo" />
        ) : (
          <LogoLoader />
        )}
      </Grid>
      <Grid className={styles.flags} item xs={5} md={3}>
        <CircleNotificationsIcon
          color="primary"
          sx={{ fontSize: "3rem" }}
        ></CircleNotificationsIcon>
        <img
          onClick={() => changeLanguage(languages.es)}
          className={`${styles.flagIcon} ${language === "es" ? styles.lgSelected : null}`}
          src={argentinaFlag}
          alt="Español"
        />
        <img
          onClick={() => changeLanguage(languages.pt)}
          className={`${styles.flagIcon} ${language === "pt" ? styles.lgSelected : null}`}
          src={brazilFlag}
          alt="Portugues"
        />
      </Grid>
    </Grid>
  );
};
